import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HelpIcon from "../../../Common/HelpIcon";
import {
  Alliance,
  Crime,
  GovernyInfo, ThiefActionType
} from "../../../../lib/types";
import { getCrimeType } from "../../../../lib/commonFunctions";

import DialogButton from "../../../Common/DialogButton";
import { cancelThieves, openDialog } from "../../../../store/actions";
import { DragescentState } from "../../../../store/reducers/stateType";
import GovernoratePivotColumn from "../../../Common/GovernoratePivotColumn";

interface IProps {
  sender: number;
  gold: number;
  opponentAlliance: Alliance;
  target: GovernyInfo;
  targetCrimes: Crime[];
  readyToThieves: boolean;
  crimeTypes: ThiefActionType[];
  limitReached: boolean;
}

const OpponentCrimes = ({
  target,
  targetCrimes,
  sender,
  gold,
  readyToThieves,
  crimeTypes,
  limitReached
}: IProps) => {
  const [currentInfluence, setCurrentInfluence] = useState<number>(0)
  useEffect(() => {
    setCurrentInfluence(0);
  }, [target, targetCrimes]);

  const getDialogOptions = () => ({
    name: "CrimeChoice",
    header: "Available crimes:",
    sender,
    target,
    influence: currentInfluence,
    gold,
    readyToThieves,
    crimeTypes,
    limitReached
  })

  const id = useSelector((state: DragescentState) => state.governorate.id);
  const openedDialog = useSelector((state: DragescentState) => state.ui.showDialog);
  const dispatch = useDispatch();

  useEffect(() => {
    if (openedDialog && openedDialog.some((d: any) => d.name === "CrimeChoice")) {
      const options = openedDialog.find((d: any) => d.name === "CrimeChoice");
      if (options.target.id === target.id) {
        dispatch(openDialog({
          ...options,
          crimeTypes,
          gold,
          limitReached,
          influence: currentInfluence,
          checkNotReload: () => false,
        }))
      }
    }
  }, [gold, limitReached, currentInfluence])

  return (
    <tr>
      <GovernoratePivotColumn
        id={target.id}
        name={target.name}
        race={target.race.name}
        commander={target.commander}
        emperor={target.emperor}
      />
      <td className="text-center">
        {target.influence || 0}
      </td>
      <td>
        <div className="row persons">
          <div className={`col-xs-5 text-right no-padding-left ${currentInfluence ? "positive" : ""}`}>
            <a
              className={`icon-minus icon align-sub ${currentInfluence ? "" : "disabled"}`}
              onClick={() => currentInfluence
                && setCurrentInfluence(currentInfluence - 1)}
            />
          </div>
          <div className="col-xs-1 text-center no-padding-right no-padding-left">
            {currentInfluence}
          </div>
          <div className={`col-xs-4 text-left no-padding-right ${target.influence && target.influence > currentInfluence ? "positive" : ""}`}>
            <a
              className={`icon-plus icon align-sub ${target.influence && target.influence > currentInfluence ? "positive" : "disabled"}`}
              onClick={() => target.influence && target.influence > currentInfluence
                && setCurrentInfluence(currentInfluence + 1)}
            />
            &nbsp;<HelpIcon
              title={"Add influence"}
              content={"Lower the price of crime by 5% and increase its effectiveness by 2,5% for each influence spend. Choose before a sending crime."}
              iconClasses={["white"]}
            />
          </div>
        </div>
      </td>
      <td className={"text-center"}>
        <DialogButton
          getDialogOptions={getDialogOptions}
        >
          Send
        </DialogButton>
      </td>
      <td className="text-center">
        {
          targetCrimes.sort((c1, c2) => (c1.typeId === 3 ? -1 : (c2.typeId === 3 ? 1 : 0)))
            .map((crime) => {
              const crimeType = getCrimeType(crime, crimeTypes);

              return crimeType
                && <>
                  {crimeType.name}&nbsp;{crime.influence
                    ? <>
                      +{crime.influence} <i className="icon icon-zlodeji align-sub"/>
                    </>
                    : ""
                }
                  <HelpIcon
                    title={crimeType.name}
                    content={crimeType.description}
                    iconClasses={["white", "align-sub"]}
                  />&nbsp;
                  <a
                    className="link"
                    onClick={() => dispatch(cancelThieves(
                      crimeType.id,
                      target.id,
                      sender,
                      sender === id
                    ))}
                  >
                    cancel
                  </a>
                  <br/>
                </>
            })
        }
      </td>
    </tr>
  )
}

export default OpponentCrimes;
